import { c as _c } from "react/compiler-runtime";
import PricePlanColumns from 'modules/profile/user-plan/components/price-plan-columns';
import PricePlanFeaturesColumn from 'modules/profile/user-plan/components/price-plan-features-column';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import getBillingPeriodFromSubscriptionPeriod from 'modules/profile/user-plan/utils/price-plan-utils';
import React, { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { dateTimeFormat } from 'shared/utils/date-time-format';
export interface UserPlanTableProps {
  currentUserPlanData: UseUserPlanInterface;
  showWithTax: boolean;
}
const UserPlanTable = t0 => {
  const $ = _c(23);
  const {
    currentUserPlanData,
    showWithTax
  } = t0;
  let t1;
  if ($[0] !== currentUserPlanData.subscriptionPeriod) {
    t1 = getBillingPeriodFromSubscriptionPeriod(currentUserPlanData.subscriptionPeriod) || BillingPeriodEnum.monthly;
    $[0] = currentUserPlanData.subscriptionPeriod;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [billingPeriod, setBillingPeriod] = useState(t1);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  let t2;
  if ($[2] !== currentUserPlanData.subscriptionPeriod) {
    t2 = () => {
      if (currentUserPlanData.subscriptionPeriod) {
        setBillingPeriod(getBillingPeriodFromSubscriptionPeriod(currentUserPlanData.subscriptionPeriod) || BillingPeriodEnum.monthly);
      }
    };
    $[2] = currentUserPlanData.subscriptionPeriod;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== currentUserPlanData) {
    t3 = [currentUserPlanData];
    $[4] = currentUserPlanData;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== currentUserPlanData.nextBillingDate || $[7] !== t || $[8] !== user) {
    t4 = currentUserPlanData.nextBillingDate && user && <div className="text-text-primary font-inter py-3 pl-4 text-lg"><div className="[&>svg]:fill-brand-primary [&>svg]:main-transition-colors flex items-center gap-1.5">{t("dashboard.settings.user_plan.next_billing_title")}<b className="text-text-primary font-inter">{dateTimeFormat(currentUserPlanData.nextBillingDate, {
            timeFormat: user?.timeFormat,
            dateFormat: user?.dateFormat,
            timeZone: user?.timezone
          })}</b></div></div>;
    $[6] = currentUserPlanData.nextBillingDate;
    $[7] = t;
    $[8] = user;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== billingPeriod || $[11] !== currentUserPlanData) {
    t5 = <PricePlanFeaturesColumn billingPeriod={billingPeriod} setBillingPeriod={setBillingPeriod} data={currentUserPlanData} />;
    $[10] = billingPeriod;
    $[11] = currentUserPlanData;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== billingPeriod || $[14] !== currentUserPlanData || $[15] !== showWithTax) {
    t6 = <PricePlanColumns currentUserPlanData={currentUserPlanData} billingPeriod={billingPeriod} showWithTax={showWithTax} />;
    $[13] = billingPeriod;
    $[14] = currentUserPlanData;
    $[15] = showWithTax;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className="flex flex-1 flex-row justify-items-center lg:grid lg:w-full lg:grid-cols-[20%_80%]">{t5}{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t4 || $[21] !== t7) {
    t8 = <div className="bg-background-secondary w-full overflow-hidden rounded-md">{t4}{t7}</div>;
    $[20] = t4;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default UserPlanTable;